module.exports = __webpack_public_path__ + "static/media/icon-question-cart.a0ed2771.svg";